import { createLocation, locationsAreEqual } from '../history';
import invariant from '../tiny-invariant';
import Lifecycle from './Lifecycle';
import RouterContext from './RouterContext';
import generatePath from './generatePath';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The public API for navigating programmatically with a component.
 */
function Redirect(props) {
  const {
    to,
    push = false
  } = props;
  const computedMatch = props.computedMatch;
  return /*#__PURE__*/_jsx(RouterContext.Consumer, {
    children: context => {
      var _to$pathname;
      invariant(context, 'You should not use <Redirect> outside a <Router>');
      const {
        history,
        staticContext
      } = context;
      const method = push ? history.push : history.replace;
      const location = createLocation(computedMatch ? typeof to === 'string' ? generatePath(to, computedMatch.params) : Object.assign({}, to, {
        pathname: generatePath((_to$pathname = to.pathname) !== null && _to$pathname !== void 0 ? _to$pathname : '/', computedMatch.params)
      }) : to);

      // When rendering in a static context,
      // set the new location immediately.
      if (staticContext) {
        method(location);
        return null;
      }
      return /*#__PURE__*/_jsx(Lifecycle, {
        onMount: () => {
          method(location);
        },
        onUpdate: (self, prevProps) => {
          // @ts-expect-error Lifecycle prevProps doesn't know about the extra 'to' prop
          const prevLocation = createLocation(prevProps.to);
          if (!locationsAreEqual(prevLocation, Object.assign({}, location, {
            key: prevLocation.key
          }))) {
            method(location);
          }
        }
        // @ts-expect-error extra prop passed to Lifecycle so onUpdate can access prevProps.to
        ,
        to: to
      });
    }
  });
}
export default Redirect;